(function () {
    'use strict';

    angular
        .module('app')
        .controller('MemberController', MemberController);

    MemberController.$inject = ['$http', '$rootScope', '$state', '$scope', 'authenticator', '$stateParams', 'emojiReplacer', 'cache', '$log', '$q', 'tourHelper'];

    function MemberController($http, $rootScope, $state, $scope, authenticator, $stateParams, emojiReplacer, cache, $log, $q, tourHelper) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;

        const vm = this;

        vm.createProfileToggle = false;

        // Related to adding info for the member
        vm.showEditUserInfo = false;
        vm.selectGenre = selectGenre;
        vm.updateUser = updateUser;

        // Navigation
        vm.logout = logout;
        vm.navigateMusician = navigateMusician;
        vm.navigateHost = navigateHost;
        vm.state = $state;
        vm.goToTab = goToTab;

        vm.closeInfoCard = closeInfoCard;
        vm.infoCardOpen = infoCardOpen;
        vm.loadConcertsAndTours = loadConcertsAndTours;
        vm.hasTours = false;

        // Controls the dropdown menu for each concert, based on its index in a
        // list.
        vm.concertActions = {};

        vm.$onInit = function () {
            window.document.title = $stateParams.language == 'da' ? "Din profil - Be My Concert" : "Your profile - Be My Concert";
            vm.tab = $stateParams.tab;

            loadConcertsAndTours();

            Promise.all([getUser(), getUserAffilliates()]).then(function () {
                getNotifications();
                getTickets();
                getPastConcerts();

                getGenres().then(function () {
                    vm.genres.forEach(function (genre) {
                        vm.user.user_genres.forEach(function (user_genre) {
                            if (genre.filter_value_id == user_genre.filter_value_id) {
                                genre.selected = true;
                            }
                        })
                    })
                });
            });
        };

        function infoCardOpen(name) {
            return cache.getSetting(name) == undefined ? true : false;
        }

        function closeInfoCard(name) {
            cache.setSetting(name, false);
        }

        function navigateMusician(e, musician) {
            e.preventDefault();
            e.stopPropagation();
            if (musician.band_is_draft == '1') {
                $state.go('edit_musician', { band_slug: musician.band_slug });
            } else {
                $state.go('musician', { band_slug: musician.band_slug });
            }
        }

        function navigateHost(e, host) {
            e.preventDefault();
            e.stopPropagation();
            if (host.space_is_draft == '1') {
                $state.go('edit_space', { space_slug: host.space_slug });
            } else {
                $state.go('host', { space_slug: host.space_slug });
            }
        }

        function refreshUpcomingConcerts() {
            Promise.all([getUpcomingConcerts(), getUpcomingBookings()]).then(function () {
                $scope.$applyAsync(() => {
                    vm.upcoming_concerts_and_bookings = sortConcertsAndBookings(vm.upcoming_concerts, vm.upcoming_bookings, "upcoming");
                    vm.hasTours = vm.upcoming_concerts_and_bookings.some(c => !!c.tour_id);
                    $log.debug('Upcoming concerts has tour?', vm.hasTours);
                });
            });
        }

        function getUpcomingBookings() {
            return $http.get('api/upcoming_bookings')
                .then(function (response) {
                    vm.upcoming_bookings = response.data;
                    if(vm.upcoming_bookings.length>0) {
                        vm.hasBooking = true;
                    }
                });
        }

        function sortConcertsAndBookings(concerts, bookings, mode) {
            const concerts_and_bookings = []

            concerts.forEach(concert => {
                concert.is_past = mode === 'past';
                concert.time = concert.concert_start_time;
                concerts_and_bookings.push(concert)
            });

            bookings.forEach(booking => {
                booking.is_past = mode === 'past';
                booking.time = moment(booking.band_booking_date.substr(0,10) + ' ' + booking.band_booking_time).toDate();
                concerts_and_bookings.push(booking);
            });

            if (mode == "past") {
                return concerts_and_bookings.sort((a, b) => new Date(b.time) - new Date(a.time));
            }

            return concerts_and_bookings.sort((a, b) => new Date(a.time) - new Date(b.time));
        }

        function goToTab(tab) {
            vm.tab = tab;
            const scrollY = window.scrollY;
            $state.transitionTo('member', { tab: tab }, {
                location: true, // This makes it update URL
                inherit: true,
                relative: $state.$current,
                notify: false // This makes it not reload
            }).then(function () {
                window.scrollTo(0, scrollY);
            });
        }

        function getUserAffilliates() {
            if (cache.exists('user_bands') && cache.exists('user_hosts')) {
                vm.user_bands = cache.load('user_bands');
                vm.user_hosts = cache.load('user_hosts');
                vm.pending_musicians = cache.load('pending_musicians');
                vm.pending_hosts = cache.load('pending_hosts');
                vm.notHostOrMusician = vm.user_bands.length == 0 && vm.user_hosts.length == 0;
                return Promise.resolve();
            } else {
                return $http.get('api/users/user_affiliates/')
                    .then(function (response) {
                        vm.user_bands = response.data.affiliates.band ? response.data.affiliates.band : [];
                        vm.user_hosts = response.data.affiliates.space ? response.data.affiliates.space : [];
                        cache.save('user_bands', vm.user_bands);
                        cache.save('user_hosts', vm.user_hosts);

                        vm.pending_musicians = response.data.pending && response.data.pending.band && response.data.pending.band.length > 0 ? true : false;
                        vm.pending_hosts = response.data.pending && response.data.pending.space && response.data.pending.space.length > 0 ? true : false;
                        cache.save('pending_musicians', vm.pending_musicians);
                        cache.save('pending_hosts', vm.pending_hosts);

                        vm.notHostOrMusician = vm.user_bands.length == 0 && vm.user_hosts.length == 0;
                        if(vm.user_bands.length > 0 && vm.user_bands[0].band_deactivated_at || vm.user_hosts.length > 0 && vm.user_hosts[0].space_deactivated_at) {
                            vm.noTabs = true;
                        }
                        vm.show_payout_missing = false;
                        vm.user_hosts.forEach((host) => {
                            if (host.space_hosting_fee > 0.00) {
                                vm.show_payout_missing = true;
                            }
                        });
                    });
            }
        }

        $scope.$on('$destroy', function () {
            $rootScope.dark_text_header = false;
            $rootScope.separate_page = false;
        })

        function getUser() {
            if (cache.exists('user')) {
                vm.user = cache.load('user');
                vm.current_img = '/app/api/upload/users/1/' + vm.user.user_slug + '/';
                return Promise.resolve();
            } else {
                return $http.get('api/private/users/')
                    .then(function (response) {
                        vm.user = response.data;
                        cache.save('user', vm.user);
                        vm.current_img = '/app/api/upload/users/1/' + vm.user.user_slug + '/';
                    });
            }
        }

        function getTickets() {
            if (cache.exists('upcoming_tickets') && cache.exists('past_tickets')) {
                vm.upcoming_tickets = cache.load('upcoming_tickets');
                vm.past_tickets = cache.load('past_tickets');
                return Promise.resolve();
            } else {
                $http.get('api/usertickets/all')
                    .then(function (response) {
                        vm.upcoming_tickets = response.data.upcoming ? response.data.upcoming : [];
                        vm.past_tickets = response.data.past ? response.data.past : [];
                        cache.save('upcoming_tickets', vm.upcoming_tickets);
                        cache.save('past_tickets', vm.past_tickets);
                    });
            }
        }

        function getUpcomingConcerts() {
            return $http.get('api/users/private/upcoming_concerts')
                .then(function (response) {
                    vm.upcoming_concerts = response.data.upcoming_concerts;
                    vm.promotion_targets = response.data.promotion_targets;
                    vm.numUpcomingConcerts = vm.upcoming_concerts.filter(function (obj) {
                        return obj.concert_published != null
                    }).length;
                    cache.save('upcoming_concerts', vm.upcoming_concerts);
                });
        }

        function getPastConcerts() {
            if (cache.exists('past_concerts')) {
                vm.past_concerts = cache.load('past_concerts');
                return Promise.resolve();
            } else {
                return $http.get('api/users/private/past_concerts')
                    .then(function (response) {
                        vm.past_concerts = response.data;
                        cache.save('past_concerts', vm.past_concerts);
                    });
            }
        }

        function getGenres() {
            if (cache.exists('genres')) {
                vm.genres = cache.load('genres');
                return Promise.resolve();
            } else {
                return $http.get('api/genres/')
                    .then(function (response) {
                        vm.genres = response.data;
                        cache.save('genres', vm.genres);
                    });
            }
        }

        function getNotifications() { //Gets notifications for current user and also returns current user-slug
            $http.get('api/notifications/')
                .then(function (response) {
                    vm.notifications = response.data;
                });
        }

        function selectedGenres() {
            const selectedGenres = [];
            vm.genres.forEach(function (genre) {
                if (genre.selected) {
                    selectedGenres.push(genre)
                }
            });
            return selectedGenres;
        }

        function selectGenre(genre) {
            if (!genre.selected && selectedGenres().length == 5) {
                return;
            }
            genre.selected = !genre.selected;
            vm.user.user_genres
        }

        function updateUser() {
            const data = {
                user_genres: selectedGenres(),
            };
            if (!vm.user.user_about) {
                vm.user.user_about = "";
            }
            data.user_about = emojiReplacer.replaceEmojis(vm.user.user_about);

            $http.patch('api/users/' + vm.slug + '/', data)
                .then(function () { //Sets cookies corresponding to the new data
                    vm.user.user_genres = [];
                    vm.genres.forEach(function (genre) {
                        if (genre.selected == true) {
                            vm.user.user_genres.push(genre);
                        }
                    })
                    cache.save('user', vm.user);
                    vm.showEditUserInfo = false;
                });
        }

        function logout() {
            authenticator.logout()
                .then(function () {
                    $rootScope.$broadcast('check_login_status');
                    $state.go('frontpage');
                });
        }

        async function loadConcertsAndTours() {
            try {
                $scope.$applyAsync(() => {
                    vm.isLoadingConcerts = true;
                });
                await Promise.all([
                    refreshUpcomingConcerts(),
                    loadTours()
                ]);
            } finally {
                $scope.$applyAsync(() => {
                    vm.isLoadingConcerts = false;
                });
            }
        }

        async function loadTours() {
            const response = await $q.when($http.get('api/users/private/tours'));
            $scope.$applyAsync(() => {
                vm.tours = response.data.tours
                    .map(tour => {
                        const { startDate, endDate } = tourHelper.getTourDates(tour);
                        tour.tour_start = startDate;
                        tour.tour_end = endDate;
                        return tour;
                    })
                    .sort((a, b) => a.tour_start - b.tour_start);
                $log.debug('Tours', vm.tours);
            });
        }
    }
})();
